const constant =  {
  OPERATOR_OPTS: [
    {name: 'Mobtexting', value: 'm1'},
    // {name: 'Videocon', value: 'v1'},
    {name: 'VIDEOCON', value: 'VIDEOCON'}
  ]
}

export default constant
